export function convertTimeToDecimal(time) {
	const [hours, minutes, seconds] = time.split(':').map(Number);
	return hours / 24 + minutes / (24 * 60) + seconds / (24 * 60 * 60);
}
